module.exports = __webpack_public_path__ + "media/images/help/about/eyecatch-reason-1-6504ee75a3c8547bee3f154177ec879e.jpg";